module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploadLayer"
  }, [_vm._t("default", [(_vm.displayImg) ? _c('img', {
    staticClass: "uploadimg",
    attrs: {
      "src": _vm.displayImg
    }
  }) : _c('img', {
    staticClass: "uploadimg",
    attrs: {
      "src": require("../assets/images/logo.png")
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "layui-upload-file",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "name": "file",
      "id": _vm.uploadId
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d4cbb24!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YmUpload.vue
// module id = 319
// module chunks = 2